// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2bp-H","large":"styles_large__1ChZA"};